import type { FaireThemeEntity } from "../../entity_types/theme";

export const everyday_non_tarnish_gold: FaireThemeEntity = {
  token: "everyday-non-tarnish-gold",
  type: "theme",
  name: "Everyday Non-Tarnish Gold",
  description: "High-quality 18K gold-plated, water-resistant, hypoallergenic pieces for long-lasting daily wear.",
  teaser: "Life-proof gold that withstands lotions and water during beauty visits.",
  detail: "Your beauty lounge customers value low-maintenance accessories that withstand lotions and water during visits. Every product -- from the Evereign necklace to the Chaplin bracelet -- is non-tarnish and water-resistant.",
  bgColor: "#F5F0D4",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_85zuvdfqvw",
    "p_ut3tbs6mrw",
    "p_pqf2f49nzz",
    "p_ufjavmwa64",
    "p_nrg5hxcuy3",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
